import { Group, Menu, Text, UnstyledButton } from '@mantine/core';
import { IconCaretDownFilled, IconWorld } from '@tabler/icons-react';
import { router, usePage } from '@inertiajs/react';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export function useLanguage() {

    const { i18n } = useTranslation();
    const { auth } = usePage().props;
    const saved = auth?.user?.language;

    // The account's language wins over whatever this browser last remembered,
    // so a user gets the same language on every machine they log in from.
    useEffect(() => {
        if (saved && saved !== i18n.resolvedLanguage) {
            i18n.changeLanguage(saved);
        }
    }, [saved]);

    const setLanguage = (lng) => {
        i18n.changeLanguage(lng);

        if (auth?.user) {
            router.post(route('studio.profile.language'), { language: lng }, {
                preserveScroll: true,
                preserveState: true,
            });
        }
    };

    return { language: i18n.resolvedLanguage, setLanguage, options: [['en', 'English'], ['de', 'Deutsch']] };
}

export function LanguageSwitcher() {

    const { language, setLanguage, options } = useLanguage();

    return (
        <Menu withArrow width={160} shadow="md" radius="md">
            <Menu.Target>
                <UnstyledButton>
                    <Group gap={4} align="center">
                        <IconWorld size="1.1rem" />
                        <Text fz="sm" fw="500" tt="uppercase">{language}</Text>
                        <IconCaretDownFilled size="0.7rem" />
                    </Group>
                </UnstyledButton>
            </Menu.Target>
            <Menu.Dropdown>
                {options.map(([lng, name]) => (
                    <Menu.Item
                        key={lng}
                        fw={language === lng ? 'bold' : undefined}
                        onClick={() => setLanguage(lng)}
                    >
                        {name}
                    </Menu.Item>
                ))}
            </Menu.Dropdown>
        </Menu>
    );
}
